import { ReactElement, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { TranslationService } from "../../services/TranslationService";
import AuthenticationContext from "./AuthenticationContext";
import { Subject } from "rxjs";

export const onClearCacheSubject = new Subject();
export const onClearCache = onClearCacheSubject.asObservable();
function Logout(props: { lang: string }): ReactElement {
  const { doLogout } = useContext(AuthenticationContext);
  const history = useHistory();
  const returnUrl = new URLSearchParams(useLocation().search).get("returnUrl");
  useEffect(() => {
    doLogout();
    onClearCacheSubject.next(false);
    // Keep returnUrl so the user goes back to the caller (e.g. Cashapp) after logging in again
    const query = returnUrl
      ? `?returnUrl=${encodeURIComponent(returnUrl)}`
      : "";
    history.replace(`/${TranslationService.currentLanguage}/logon${query}`);
  }, [doLogout, history, returnUrl]);
  return <></>;
}

export default Logout;
